export function NotFound() {
    return <>"Oops, 404"</>;
}
